export default __webpack_public_path__ + "static/media/gr.bbe33ba4.svg";